(function() {
    'use strict';

    angular
        .module('jotApp')
        .directive('multiSortBy', multiSortBy);

    function multiSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^multiSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.multiSortBy);
            });
        }
    }
})();
